import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';

import {
    InitialCausality,
    InitialCausalityHistorical,
} from '../../../../shared/types/typifications/initialCausality';
import { ToastSwal } from '../../../components/general/toastSwals/toastSwal';

import {
    INITIAL_CAUSALITY,
    INITIAL_CAUSALITY_DETAIL,
} from '../../../../routes/paths';

import {
    asyncCreateInitialCausality,
    asyncUpdateInitialCausality,
    asyncGetInitialCausality,
    asyncGetInitialCausalityHistorical,
} from '../../../../services/initial.causality.service';
import { cleanObj } from '../../../../shared/utils/objects';

export const useInitialCausalityForm = (showHistorical: boolean) => {
    const navigate = useNavigate();
    const { idInitialCausality } = useParams();
    const [initialCausality, setInitialCausality] =
        useState<InitialCausality>();
    const [loading, setLoading] = useState(false);
    const [formikInitialCausalityData, setFormikInitialCausalityData] =
        useState<FormikProps<InitialCausality>>();
    const [initialCausalityHistorical, setInitialCausalityHistorical] =
        useState<InitialCausalityHistorical[]>();

    const isValidForm = formikInitialCausalityData?.isValid;

    const handleCleanAndBack = () => {
        if (initialCausality && initialCausality.id) {
            navigate(`${INITIAL_CAUSALITY_DETAIL}/${initialCausality?.id}`);
        } else {
            navigate(`${INITIAL_CAUSALITY}`);
        }
        formikInitialCausalityData?.resetForm();
    };

    const handleSubmit = async () => {
        await formikInitialCausalityData?.submitForm();

        if (!isValidForm) return;

        setLoading(true);

        const data: InitialCausality =
            (cleanObj(
                formikInitialCausalityData?.values
            ) as InitialCausality) || {};
        let res: any | undefined = undefined;

        try {
            if (initialCausality && initialCausality.id)
                res = await asyncUpdateInitialCausality(
                    initialCausality.id,
                    data
                );
            else res = await asyncCreateInitialCausality(data);
        } catch (error) {}

        if (res) {
            ToastSwal.fire({
                text: `¡Felicidades! La redirección se ${
                    initialCausality && initialCausality.id
                        ? 'actualizo'
                        : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
            navigate(`${INITIAL_CAUSALITY_DETAIL}/${res?.id}`);
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    initialCausality && initialCausality.id
                        ? 'actualizar'
                        : 'crear'
                } la redirección. Por favor, asegúrate de ${
                    initialCausality && initialCausality.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    useEffect(() => {
        if (Boolean(idInitialCausality?.trim())) {
            setLoading(true);
            asyncGetInitialCausality(idInitialCausality?.trim())
                .then((initialCausality: any) => {
                    if (!initialCausality) navigate(INITIAL_CAUSALITY);
                    setInitialCausality(initialCausality);
                })
                .finally(() => setLoading(false));
        }
    }, [idInitialCausality]);

    useEffect(() => {
        if (showHistorical && Boolean(idInitialCausality?.trim())) {
            setLoading(true);
            asyncGetInitialCausalityHistorical(idInitialCausality?.trim())
                .then((resp) => {
                    if (resp) setInitialCausalityHistorical(resp);
                    else navigate(INITIAL_CAUSALITY);
                })
                .finally(() => setLoading(false));
        }
    }, [showHistorical]);

    return {
        initialCausality,
        loading,
        isValidForm,
        handleSubmit,
        handleCleanAndBack,
        setFormikInitialCausalityData,
        initialCausalityHistorical,
    };
};
